import type { TemplateName } from "../types/route-context";

const TEMPLATE_CLASS_PREFIX = "template-";

export function detectTemplateNameFromClassNames(classNames: Iterable<string>): TemplateName {
  const templateClass = Array.from(classNames).find((className) =>
    className.startsWith(TEMPLATE_CLASS_PREFIX)
  );

  if (!templateClass) {
    return "unknown";
  }

  const normalized = templateClass
    .slice(TEMPLATE_CLASS_PREFIX.length)
    .toLowerCase();

  if (normalized.includes("index")) return "home";
  if (normalized.includes("collection")) return "collection";
  if (normalized.includes("product")) return "product";
  if (normalized.includes("search")) return "search";
  if (normalized.includes("cart")) return "cart";
  if (normalized.includes("blog")) return "blog";
  if (normalized.includes("article")) return "article";
  if (normalized.includes("customers")) return "customer";
  if (normalized.includes("password")) return "password";
  if (
    normalized.includes("gift-card") ||
    normalized.includes("gift_card") ||
    normalized.includes("giftcard")
  ) {
    return "gift_card";
  }
  if (normalized.includes("page")) return "page";

  return "unknown";
}

export function detectTemplateNameFromBody(body: HTMLBodyElement): TemplateName {
  return detectTemplateNameFromClassNames(body.classList);
}
